<template>
  <vjs-modal v-bind="$options.propsData"
             :name="name"
             :title="title"
             :icon="icon">
    <ul class="col-checkboxes clean-list d-flex flex-column flex-wrap">
      <li v-for="col of columns" :key="col.field">
        <ss-checkbox :id="`${tableId}-${col.field}`" :checked="col.visible" @change="(checked) => emitColToggle(col, checked)">
          {{ col.display }}
        </ss-checkbox>
      </li>
    </ul>
  </vjs-modal>
</template>

<script>
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: 'fdt-cols-modal',
    },
    title: {
      type: String,
      required: false,
      default: 'Toggle Column Visibility',
    },
    icon: {
      type: String,
      required: false,
      default: 'la la-list',
    },
    columns: {
      type: Array,
      required: true,
    },
    tableId: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitColToggle(col, visible) {
      this.$emit('toggle', {
        col,
        visible,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.col-checkboxes {
  max-height: 110px;
}
</style>
